<template>
  <div class="tag" @click="onClickComponentTag">
    <div class="thumb">
      <img v-if="imageUrl" :src="imageUrl" />
      <svg-icon v-else ref="icon" :icon="icon" :width="'20'" :height="'20'" />
    </div>
    <div class="name">
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from '../../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  props: {
    item: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('project/data/components', [
      'getCoverId',
      'getCoverIcon',
      'getDefaultIcon',
    ]),
    ...mapGetters('project/data/assets', ['getSmallImageUrl']),

    /**
     * Return the cover asset id for the component
     * @return {String|null}
     */
    coverId() {
      return this.getCoverId(this.item.id);
    },

    /**
     * Return the url of the small image of the cover asset
     * @returns {String|null}
     */
    imageUrl() {
      return this.getSmallImageUrl(this.coverId);
    },

    /**
     * Return the icon of the cover asset
     */
    icon() {
      return this.getCoverIcon(this.item.id) || this.getDefaultIcon;
    },
  },

  methods: {
    onClickComponentTag() {
      this.$emit('clickComponentTag');
    },
  },
};
</script>

<style lang="scss" scoped>
.tag {
  display: flex;
  background: #252929;
  border-radius: 4px;
  align-items: center;
  margin: 0 10px 10px 0;
  overflow: hidden;
  outline: 1px solid transparent;
  transition: outline ease 0.1s;
  &:hover {
    outline: 1px solid #db841e;
    .name {
      color: #fff;
    }
  }

  .thumb {
    width: 36px;
    height: 36px;
    background: #181c1c;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .name {
    padding: 0 12px 0;
    color: #bcbcbc;
    font-weight: 600;
    flex-shrink: 0;
    transition: color ease 0.1s;
  }
}
</style>
